import * as yup from 'yup';

const validationSchema = yup.object({
  type: yup.string().required('Required'),
  documents: yup.array().min(1, 'At least one document is required'),
});

export default validationSchema;
